import axiosBaseService from './base-axios-api'
import BaseApi from './base-api';

export const customerConfigApi = new BaseApi('api/configuration');

customerConfigApi.getConfigurations = function (u = '', q) {
    return axiosBaseService({
        url: this.composeUrl(this.url, '', u),
        method: 'get',
        withCredentials: false,
        params: q
    })
}